import React from 'react';
export function Testimonials() {
  return <section className="py-16 bg-white" data-id="element-253">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254">
        <div className="text-center mb-12" data-id="element-255">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-256">
            What Readers Are Saying
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-257">
            Join hundreds of others who have already transformed their mindset
            and regained their vitality.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-258">
          <div className="bg-blue-50 p-6 rounded-lg" data-id="element-259">
            <div className="flex mb-4" data-id="element-260">
              {[...Array(5)].map((_, i) => <svg key={i} className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-261">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-262" />
                </svg>)}
            </div>
            <blockquote className="text-gray-700 mb-4" data-id="element-263">
              "I was skeptical at first, but the mental reset techniques in this
              guide have completely changed how I approach each day. I feel 10
              years younger mentally!"
            </blockquote>
            <div className="flex items-center" data-id="element-264">
              <div className="h-10 w-10 rounded-full bg-blue-200 flex items-center justify-center text-blue-600 font-bold" data-id="element-265">
                JM
              </div>
              <div className="ml-3" data-id="element-266">
                <p className="text-sm font-medium text-gray-900" data-id="element-267">Jennifer M.</p>
                <p className="text-sm text-gray-500" data-id="element-268">Age 42</p>
              </div>
            </div>
          </div>
          <div className="bg-blue-50 p-6 rounded-lg" data-id="element-269">
            <div className="flex mb-4" data-id="element-270">
              {[...Array(5)].map((_, i) => <svg key={i} className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-271">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-272" />
                </svg>)}
            </div>
            <blockquote className="text-gray-700 mb-4" data-id="element-273">
              "The mindfulness practices and nutritional advice have given me
              more energy than I've had in decades. Best $9.99 I've ever spent
              on my well-being."
            </blockquote>
            <div className="flex items-center" data-id="element-274">
              <div className="h-10 w-10 rounded-full bg-blue-200 flex items-center justify-center text-blue-600 font-bold" data-id="element-275">
                DT
              </div>
              <div className="ml-3" data-id="element-276">
                <p className="text-sm font-medium text-gray-900" data-id="element-277">David T.</p>
                <p className="text-sm text-gray-500" data-id="element-278">Age 55</p>
              </div>
            </div>
          </div>
          <div className="bg-blue-50 p-6 rounded-lg" data-id="element-279">
            <div className="flex mb-4" data-id="element-280">
              {[...Array(5)].map((_, i) => <svg key={i} className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-281">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-282" />
                </svg>)}
            </div>
            <blockquote className="text-gray-700 mb-4" data-id="element-283">
              "I've read dozens of self-help books, but this guide actually
              delivers practical techniques I could implement immediately. My
              mental clarity has improved dramatically."
            </blockquote>
            <div className="flex items-center" data-id="element-284">
              <div className="h-10 w-10 rounded-full bg-blue-200 flex items-center justify-center text-blue-600 font-bold" data-id="element-285">
                SK
              </div>
              <div className="ml-3" data-id="element-286">
                <p className="text-sm font-medium text-gray-900" data-id="element-287">Sarah K.</p>
                <p className="text-sm text-gray-500" data-id="element-288">Age 37</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}